import { ref } from 'vue';
import { getPdfUrlApi } from '@Api/pdf.api';

export function usePdfDownload() {
    const isPdfLoading = ref(false);
    const pdfError = ref<string | null>(null);

    const downloadPdf = async () => {
        if (isPdfLoading.value) return;

        // Open a blank tab synchronously while still inside the user gesture,
        // before any async work. Browsers allow window.open() here; after an
        // await they may block it as a popup.
        //
        // NOTE: Do NOT pass 'noopener' here. Per the HTML spec, window.open()
        // returns null when noopener is set, which would immediately trigger
        // the "allow popups" error even though the tab did open successfully.
        // We drop the opener reference manually after navigating (see below).
        const tab = window.open('', '_blank');
        if (!tab) {
            pdfError.value = 'Unable to open PDF — please allow popups for this site and try again.';
            return;
        }

        isPdfLoading.value = true;
        pdfError.value = null;

        try {
            const url = await getPdfUrlApi();
            tab.location.href = url;
            // Sever the opener reference now that we have navigated, so the
            // opened tab cannot access this window via window.opener.
            tab.opener = null;
        } catch (err) {
            tab.close();
            pdfError.value = 'Failed to generate PDF. Please try again.';
        } finally {
            isPdfLoading.value = false;
        }
    };

    return {
        isPdfLoading,
        pdfError,
        downloadPdf,
    };
}